'use client';

import dynamic from 'next/dynamic';

export const VideoPlayerContainerWrapper = dynamic(
  async () => {
    const [{ default: C4DVideoPlayerContainer }, { createComponent }, React] = await Promise.all([
      import(
        '@carbon/ibmdotcom-web-components/es/components/video-player/video-player-container.js'
      ),
      import('@lit/react'),
      import('react'),
    ]);

    return createComponent({
      tagName: 'c4d-video-player-container',
      elementClass: C4DVideoPlayerContainer,
      react: React,
    });
  },
  // Web components need to be loaded in the browser, not SSR
  { ssr: false }
);

VideoPlayerContainerWrapper.displayName = 'VideoPlayerContainerWrapper';
